import { Injectable } from '@angular/core';
import { Component, Input, OnInit } from "@angular/core";
import { HttpBackend, HttpClient } from "@angular/common/http";
import * as jose from 'jose'; 
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from '../../environments/environment';
import { catchError, from, map, of, switchMap } from 'rxjs';

@Component({
  selector: 'ngbd-modal-content',
  styleUrls: ['../modal.component.css'], // Add this line
  template: `
  <div >
       <div class="modal-body text-center ac-error-msg p-4">
      <p>
    <svg xmlns="http://www.w3.org/2000/svg" height="72" viewBox="0 -960 960 960" width="72"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z" fill="#FA4628"/></svg></p>
      <h2>Session Expired</h2>
        <p class="ac-modelpara p-3">{{name}}</p>
      </div>
      </div>
    `
})

export class NgbdModalContent {
  @Input() name: any;
  @Input() status: any;
  @Input() success: any = "none";
  @Input() error: any = "none";
  @Input() className: any;
  isPayClicked: boolean = false;
  supportLanguages = ['en'];
  constructor(public activeModal: NgbActiveModal) {
  }
  closed() {
    this.activeModal.close();
  }

}

export interface JWKValidate {
	jwk: any;
	token: string;
}

@Injectable({
  providedIn: 'root'
})
export class ValidateTokenService {
  private httpClient: HttpClient;

  constructor(httpBackend: HttpBackend, private modalService: NgbModal,) {
    this.httpClient = new HttpClient(httpBackend);
    
  }

  validateToken() {
    var azureClientID = environment.billingProps.aud;
    //JSON.parse( localStorage.getItem("BillingPortalProps")??"").AzureClientID;
    const azureToken: any =
    JSON.parse(
      localStorage.getItem(
        JSON.parse(
          localStorage.getItem(
            `msal.token.keys.${azureClientID}`
          ) ?? ""
        ).accessToken[0]
      ) ?? ""
    )?.secret ?? "";
    return this.fetchJWKSUri(azureToken);
  }

  fetchJWKSUri(azureToken:any) {
    const url = `https://${environment.auzreAuthDomain!}/${environment.azurePrimaryDomain!}/B2C_1__ewp_signin_${environment.azureFlowSuffix!}/discovery/v2.0/keys`
    return this.httpClient.get(url).pipe(
      switchMap((response: any) => {
        const e: string = response.keys[0].e;
        const n: string = response.keys[0].n;
        const jwkPublicKey = {
          kty: "RSA",
          n: n,
          e: e,
        };

        // Convert the Promise to an Observable using from()
        return from(jose.importJWK(jwkPublicKey, 'RS256')).pipe(
          switchMap((joseResp) => {
            const data: JWKValidate = {
              jwk: joseResp,
              token: azureToken,
            };
            // Convert the Promise to an Observable using from()
            return from(jose.jwtVerify(data.token, data.jwk)).pipe(
              map(jwtVerifyResult => jwtVerifyResult), // Just return the result
              catchError(this.handleJwtError)
            );
          }),
          catchError(this.handleJwtError)
        );
      }),
      catchError((err: any) => {
        console.error("Error fetching JWKS URI:", err); // More specific error message
        return of(this.open("You have been logged out from your current session!")); // Or handle differently
      })
    );
	}

  handleJwtError(err: any){
    console.log("Error when trying to validate token")
    console.log(err);
    return of(this.open("You have been logged out from your current session!"));
  }

  open(message: any) {
    const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.name = message;
      modalRef.componentInstance.success = "none";
      modalRef.componentInstance.error = "block";
      // await this.sleep(2000);
      //this.modalService.dismissAll();
      // parent.location = location.origin;
  }
 
  sleep(ms:any) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
